<template>
    <div v-html="payUrl"></div>
</template>
<script>
import { wxRequest} from '@/api/user'
export default {
    data(){
        return{
            payUrl:'',
            orderNo:''
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            if(!this.$route.query.orderNo) return
            wxRequest("order/aliPay/info", {orderNo:this.$route.query.orderNo}, "post").then(res => { 
                if(res.data.code == 200){
                    this.payUrl = res.data.data;
                    this.$nextTick(()=>{
                        document.forms[0].submit()
                    })
                }
            })
        }
    }
}
</script>
